import { ClientInferRequest } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { Client } from "#modules/clients/infra/Client.dto";

type CreateClientDto = ClientInferRequest<typeof contract.clients.create>["body"];

export const createClient = async (payload: CreateClientDto): Promise<Client | null> => {
  const response = await api.clients.create.mutation({
    body: payload,
  });

  if (response.status === 201) {
    return response.body;
  }

  return null;
};
